import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '/api',
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN'
});

if (import.meta.env.DEV) {
    api.interceptors.request.use((config) => {
        const fullUrl = new URL(config.url || '', config.baseURL || window.location.origin);
        // @ts-ignore
        config.httpsAgent = fullUrl.protocol === 'https:' ? {
            rejectUnauthorized: false
        } : undefined;
        return config;
    });
}



// Define public endpoints that don't require authentication
const publicEndpoints = ['/auth/login-user', '/auth/login-kiosk', '/auth/refresh','toolbox/contact-email'];

// Define endpoints where 401 errors should not trigger a redirect
const noRedirectOn401 = ['/auth/me', ...publicEndpoints];

// Flag to prevent multiple refresh token requests
let isRefreshing = false;
// Store pending requests that should be retried after token refresh
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve();
        }
    });
    failedQueue = [];
};

// javascript
// src/api.js - updated response interceptor: attempt refresh for 401s,
// but avoid redirect for endpoints listed in `noRedirectOn401`.
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        console.log('Intercepted error:', error);
        console.log('Original request:', originalRequest);

        // Only handle 401s and avoid intercepting the refresh request itself
        if (error.response?.status !== 401 || originalRequest.url?.includes('/auth/refresh')) {
            return Promise.reject(error);
        }

        // Decide whether we should skip redirecting to login if refresh fails
        const skipRedirect = noRedirectOn401.some(endpoint => originalRequest.url?.includes(endpoint));

        // If the request hasn't been retried yet
        if (!originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then(() => api(originalRequest))
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                await api.post('/auth/refresh');

                processQueue(null);

                return api(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError);
                if (!skipRedirect) {
                    window.location = '/';
                }
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        // If we've already tried to refresh and it still fails, redirect unless skipped
        console.log('Redirecting to login...');
        if (!skipRedirect) {
            window.location = '/';
        }
        return Promise.reject(error);
    }
);


// api.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;
//         console.log('Intercepted error:', error);
//         console.log('Original request:', originalRequest);
//         // If error is not 401 or it's a failed refresh token request, reject
//         if (error.response?.status !== 401 || originalRequest.url === '/auth/refresh') {
//             return Promise.reject(error);
//         }
//
//         if (noRedirectOn401.some(endpoint => originalRequest.url?.includes(endpoint))) {
//             return Promise.reject(error);
//         }
//
//         // If the request hasn't been retried yet
//         if (!originalRequest._retry) {
//             if (isRefreshing) {
//                 // If already refreshing, add request to queue
//                 return new Promise((resolve, reject) => {
//                     failedQueue.push({ resolve, reject });
//                 })
//                     .then(() => api(originalRequest))
//                     .catch((err) => Promise.reject(err));
//             }
//
//             originalRequest._retry = true;
//             isRefreshing = true;
//
//             try {
//                 // Attempt to refresh the token
//                 await api.post('/auth/refresh');
//                
//                 processQueue(null);
//                
//                 // Retry the original request
//                 return api(originalRequest);
//             } catch (refreshError) {
//                 processQueue(refreshError);
//                 // If refresh fails, redirect to login
//                 window.location = '/';
//                 return Promise.reject(refreshError);
//             } finally {
//                 isRefreshing = false;
//             }
//         }
//
//         // If we've already tried to refresh, redirect to login
//         console.log('Redirecting to login...');
//         window.location = '/';
//         return Promise.reject(error);
//     }
// );

api.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);

export default api;